/** Kira listesi filtre dropdown sabitleri */

export const PLATE_SEARCH_MODE = [
  {value: '0', label: 'Plakayı Normal Ara'},
  {value: '1', label: 'Değişimlerde Ara'},
] as const

export const RENTAL_LIST_DATE_FILTER_TYPE = [
  {value: '0', label: 'Tarih Önemsiz'},
  {value: '1', label: 'Başlangıç Tarihi'},
  {value: '2', label: 'Bitiş Tarihi'},
  {value: '3', label: 'Kira Zamanı'},
  {value: '4', label: 'İşlem Tarihi'},
  {value: '5', label: 'Taksit Tarihi'},
  {value: '6', label: 'Kapatma Tarihi'},
  {value: '7', label: 'Opsiyon Tarih'},
  {value: '8', label: 'Vade Tarihi'},
] as const

/** Kira durumu: Kirada, RentTo, Döndü, İptal */
export const RENT_LIST_STATUS = [
  {value: '0', label: 'Kirada'},
  {value: '1', label: 'RentTo'},
  {value: '2', label: 'Döndü'},
  {value: '3', label: 'İptal'},
] as const

export const INVOICE_STATUS_FILTER = [
  {value: '0', label: 'Faturalanmış'},
  {value: '1', label: 'Faturalanmamış'},
  {value: '2', label: 'Fatura bilgisi'},
] as const

export const SUMMARY_INFO_FILTER = [
  {value: '0', label: 'Özet Bilgi'},
  {value: '1', label: 'Detaylı Bilgi'},
] as const

export const RENT_OFFICE_FILTER_TYPE = [
  {value: '0', label: 'Ofis Önemsiz'},
  {value: '1', label: 'İşlem Ofisi'},
  {value: '2', label: 'Çıkış Ofisi'},
  {value: '3', label: 'Dönüş Ofisi'},
  {value: '4', label: 'Otopark'},
  {value: '5', label: 'Çıkış Bölgesi'},
  {value: '6', label: 'Dönüş Bölgesi'},
] as const

export const RAC_TABLET_USAGE = [
  {value: '0', label: 'Hepsi'},
  {value: '1', label: 'Kullanılan'},
  {value: '2', label: 'Kullanılmayan'},
] as const

export const DOCUMENT_STATUS_FILTER = [
  {value: '0', label: 'Yüklü Olanlar'},
  {value: '1', label: 'Olmayanlar'},
] as const

export const RENTAL_TYPE_FILTER = [
  {value: '0', label: 'Kısa Kiralama'},
  {value: '1', label: 'Uzun Kiralama'},
  {value: '2', label: 'Ikame'},
  {value: '3', label: 'Aylık'},
] as const

export const PERSONNEL_FILTER_ROLE = [
  {value: '0', label: 'Personel'},
  {value: '1', label: 'Kiraya Veren'},
  {value: '2', label: 'Araç Teslim Eden'},
  {value: '3', label: 'Araç Teslim Alan'},
  {value: '4', label: 'Rezervasyon Alan'},
] as const

export const BALANCE_FILTER = [
  {value: '0', label: 'Hepsi'},
  {value: '1', label: 'Bakiyeli Olanlar'},
  {value: '2', label: 'Faturalı Olanlar'},
] as const
